import { createMakeSelectCurrentPage } from "lib/providers/pagination-provider/selectors";
import { createSelector } from "reselect";

import { makeSelectAllUsers } from "../user/selectors";
import { makeSelectEntityStatuses } from "../entity_status";
import { makeSelectStringSource } from "../stringResources/selectors";
import { makeSelectImage } from "../images/selectors";
import { makeSelectVideo } from "../videos";

const selectEntity = state => state.entities.answer_option;
const selectEntityData = state =>
  state.entities.answer_option && state.entities.answer_option.data
    ? state.entities.answer_option.data
    : {};

export const makeSelectAnswerOptions = paginationKey =>
  createSelector(
    [
      selectEntityData,
      createMakeSelectCurrentPage(paginationKey)(),
      makeSelectAllUsers(),
      makeSelectEntityStatuses(),
      makeSelectStringSource(),
      makeSelectImage(),
      makeSelectVideo()
    ],
    (substate, page, users, entityStatuses, resources, images, videos) => {
      if (!paginationKey) {
        return { ...substate };
      }

      if (page.length > 0)
        return page
          .map(id => {
            if (!substate[id]) {
              return null;
            }
            const answer = { ...substate[id] };
            answer.entityStatus = entityStatuses[answer.entity_status.id];

            if (answer.answer_type === "TEXT")
              for (let resource of resources) {
                if (resource.id === answer.string_resources.id) {
                  answer.string_resources = resource;
                }
              }
            if (answer.answer_type === "IMAGE") {
              for (let image of images) {
                if (image.id === answer.image_id) {
                  answer.string_resources = image;
                  answer.image = image;
                }
              }
            }
            if (answer.answer_type === "VIDEO") {
              for (let video of videos) {
                if (video.id === answer.video_id) {
                  answer.string_resources = video;
                  answer.video = video;
                }
              }
            }

            return answer;
          })
          .filter(row => row);

      return [];
    }
  );

export const makeSelectAnswerLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
    return false;
  });

export const makeSelectAnswerError = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.error;
  });
